import { render, staticRenderFns } from "./PageAudio.vue?vue&type=template&id=5af9d760"
import script from "./PageAudio.vue?vue&type=script&lang=js"
export * from "./PageAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports